<div class="checkin__page__up__wrapper checkin__page__up__wrapper--{{ type }} checkin__page__up__wrapper--{{ type }}--{{ position }}">
  <div class="checkin__page__up__scroll" *ngIf="position === 'bottom' && (scroll || bigWidth)" (scroll)="onScroll()" (click)="onScroll()">
    <div></div>
  </div>
  <div
    #fullEl
    class="checkin__page__up__top checkin__page__up__top--{{ type }} checkin__page__up__top--{{ type }}--{{ position }}">
    <ng-content select=[top]></ng-content>
  </div>
  <div class="checkin__page__up__bottom checkin__page__up__bottom--{{ type }} checkin__page__up__bottom--{{ type }}--{{ position }}">
    <ng-content select=[bottom]></ng-content>
  </div>
</div>
